var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("main-layout", [
    _c(
      "div",
      { staticClass: "container" },
      [
        _c("H1", { staticClass: "pageTitle" }, [_vm._v("RENEW SUBSCRIPTION")]),
        _vm._v(" "),
        _c("div", { staticClass: "top40" }, [
          _vm._v(
            "\n       Please make sure you have updated your payment source "
          ),
          _c(
            "b",
            {
              staticClass: "handCursor",
              on: {
                click: function($event) {
                  return _vm.$router.push("/pmtsrc")
                }
              }
            },
            [_vm._v("here")]
          ),
          _vm._v(
            ". \n       Then check the contents of the subscription to make sure you want to renew all products contained within it. \n       "
          ),
          _c("i", [
            _vm._v(
              "Any products you unckeck will be removed immediately upon submitting this form"
            )
          ]),
          _vm._v(
            ". When you are ready, click the renew button to submit your payment.  \n       This amount will be billed for this subscription every year.\n    "
          )
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "top20 limitWidth", attrs: { id: "subsLoader" } },
          [
            _c("div", { staticClass: "bottom10" }, [
              _c("b", [_vm._v("Subscription Contents:")])
            ]),
            _vm._v(" "),
            _c(
              "table",
              { attrs: { width: "100%" } },
              [
                _c("tr", [
                  _c("td"),
                  _vm._v(" "),
                  _c("td", { attrs: { width: "20%" } }, [
                    _c("b", [_vm._v("Type")])
                  ]),
                  _vm._v(" "),
                  _c("td", [_c("b", [_vm._v("Description")])])
                ]),
                _vm._v(" "),
                _vm._l(_vm.slinkItems, function(item) {
                  return _c("tr", { key: item.id }, [
                    _c("td", [
                      _c("input", {
                        attrs: { type: "checkbox", checked: "" },
                        on: {
                          click: function($event) {
                            return _vm.removeItem(item)
                          }
                        }
                      })
                    ]),
                    _c("td", [_vm._v(_vm._s(item.type))]),
                    _c("td", [_vm._v("'" + _vm._s(item.slink) + "'")])
                  ])
                }),
                _vm._v(" "),
                _vm._l(_vm.packItems, function(item) {
                  return _c("tr", { key: item.id }, [
                    _c("td", [
                      _c("input", {
                        attrs: { type: "checkbox", checked: "" },
                        on: {
                          click: function($event) {
                            return _vm.removeItem(item)
                          }
                        }
                      })
                    ]),
                    _vm._v(" "),
                    _c("td", [_vm._v(_vm._s(item.type))]),
                    _vm._v(" "),
                    _c("td", [
                      _vm._v(
                        "Attached to slink '" +
                          _vm._s(item.attachedToSlink) +
                          "'"
                      )
                    ])
                  ])
                })
              ],
              2
            ),
            _vm._v(" "),
            _c("div", { staticClass: "top20 is-size-3" }, [
              _vm._v("$" + _vm._s(_vm.az.formatCurrency(this.total)))
            ]),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "button top10 is-warning",
                attrs: { disabled: _vm.auth },
                on: { click: _vm.sbmtPmt }
              },
              [_vm._v("SUBMIT")]
            )
          ]
        ),
        _vm._v(" "),
        _c("br"),
        _vm._v(" "),
        _c("br")
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-12061700", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-12061700","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/SubsUpdate.vue
// module id = null
// module chunks = 